import {LEAGUES} from "../constants/leagues";

/**
 * «Давление ботов» — скрытый гандикап против сильных живых игроков в
 * РЕЙТИНГОВЫХ партиях. Боты слишком легко проигрывали сильным игрокам, а
 * честный алгоритм уже вытюнен; здесь два независимых рычага (заводилось
 * это под золото, сейчас порог поднят до алмаза — см. ниже):
 *
 *  1. ФОКУС — боты сообща считают такого игрока приоритетной мишенью. Это
 *     ВЕС к оценке целей, а не приказ: бот по-прежнему развивается и не идет
 *     через полкарты ради лидера, но при прочих равных выбирает действие
 *     против него. Иначе в смешанном лобби боты бросали бы экономику и
 *     дарили победу второму живому игроку.
 *  2. КОСТИ — пол броска d6 у ботов поднимается на 1 в ближнем бою и
 *     стрельбе ПРОТИВ такого игрока (между собой боты кидают как раньше).
 *
 * Кто под давлением:
 *  - алмаз, рубин и божественная лига — оба рычага включаются на старте
 *    раунда, если отрыв игрока от ближайшего конкурента >=
 *    BOT_PRESSURE_LEAD_THRESHOLD. Одной лиги мало: пока игрок идет вровень с
 *    остальными, боты играют как обычно;
 *  - бронза, серебро и золото — не трогаем: до алмаза игроку хватает ботов
 *    без дополнительного давления. У явных рейтинговых ботов при этом
 *    остается бонус их лиги (экономика, рост отрядов, у божественных — и
 *    кости, см. configs/playerBonus).
 * Списки лиг у рычагов сейчас совпадают, но остаются раздельными: раньше
 * фокус включался с серебра, а кости с золота, и разойтись они могут снова.
 *
 * Оба признака ЗАЩЕЛКИВАЮТСЯ: включились на старте раунда — действуют до
 * конца матча, даже если игрок просел. Так поведение ботов не мигает
 * посреди партии и воспроизводится в тестах.
 */

// Лиги, чей игрок вообще попадает под давление
export const BOT_PRESSURE_FOCUS_LEAGUES = [LEAGUES.DIAMOND, LEAGUES.RUBY, LEAGUES.GOD];

// Лиги, где отрыв дополнительно поднимает пол броска костей ботов
export const BOT_PRESSURE_DICE_LEAGUES = [LEAGUES.DIAMOND, LEAGUES.RUBY, LEAGUES.GOD];

// Отрыв в очках победы от ближайшего конкурента, с которого включается
// давление (и фокус, и кости — начиная с алмазной лиги игрока)
export const BOT_PRESSURE_LEAD_THRESHOLD = 10;

// На сколько поднимается пол броска d6 у бота против игрока под давлением.
// Именно пол, а не прибавка к результату: механика та же, что у подкрутки
// костей уровнем бонуса (getBotD6MinRoll), поэтому потолок 6 не ломается и
// грани кости урона остаются в своем диапазоне
export const BOT_PRESSURE_DICE_MIN_ROLL_BONUS = 1;

// Множитель к весу действий против игрока под фокусом (захват его городов,
// атака его отрядов, блокировка его ключевых точек). Вес, а не правило —
// см. комментарий выше
export const BOT_PRESSURE_TARGET_WEIGHT = 1.6;

// Доля обычного градиента продвижения (BOT_WEIGHTS.APPROACH_TARGET_PER_CELL),
// с которой боты дополнительно тянутся к кварталам игрока под фокусом. Нужна,
// чтобы множители выше работали не только у отрядов, уже стоящих рядом.
// Держится маленькой сознательно: сильная тяга — это и есть «бросить развитие
// и маршировать через полкарты», от чего вес и должен отличаться.
// Замер (server/scripts/tmpBotPressureExperiment.js, 45 пар зеркальных
// 4-местных партий на общих сидах): 0.6 отнимает у лидера 7.0 очка и 11 п.п.
// винрейта, 0 — только 4.8 очка и 4 п.п.; при 0.6 остальные боты играют не
// хуже, а лучше — развитие они не бросают
export const BOT_PRESSURE_APPROACH_WEIGHT = 0.6;
